import * as React from 'react';
import { replacePlaceholders, __ } from '../../helpers/TranslationService';

interface IOptionsComponent {
    option: {
        value: string;
        label?: string;
        id: number;
        type: string;
        maxDiscount?: number;
    };
    onSelect(val): void;
}
// @TODO Unify Options and Value components
export class CabinOptionComponent extends React.Component<IOptionsComponent> {
    handleClick = () => this.props.onSelect(this.props.option.id);

    render() {
        const discountText = replacePlaceholders(__('upToXDiscount', 'dreamlines'), [
            `-${this.props.option.maxDiscount}%`,
        ]);

        return (
            <div className="cabinSelectOptions" onClick={this.handleClick}>
                <span>{this.props.option.label}</span>
                {this.props.option.maxDiscount && <div className="discount">{discountText}</div>}
            </div>
        );
    }
}
export const CabinValueComponent = (props) => (
    <div className="cabinSelect">
        <span>{props.value.label}</span>
    </div>
);
